import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { LocaleService } from '../../../services/locale.service';

@Component({
  selector: 'app-pagamento-add',
  templateUrl: './pagamento-add.component.html',
  styleUrls: ['./pagamento-add.component.css']
})
export class PagamentoAddComponent implements OnInit {
	@Input() datiPratica: any = {};
	@Input() writePermission: boolean = false;
	@Output() innerEvents = new EventEmitter();

	canaliPagamentoSync: Subscription;
	emissioniSync: Subscription;
	praticheSync: Subscription;

	canaliPagamento: any[] = [];
	emissioni: any[] = [];

	searchId: number;
	dataPagamento: any = null;
	dataAccredito: any = null;
	sommaPagata: any = this.formatter.twoDigitsDecimal(0);
	rata: any = 0;
	canale: any = null;
	riferimentoBollettino: any = null;

	constructor(
		private dataService: DataService,
		private formatter: LocaleService
		) {}

	ngOnInit() {
		this.canaliPagamentoSync = this.dataService.canaliPagamento$.subscribe(
			canaliPagamento => {
				this.canaliPagamento = canaliPagamento;
			});
		this.emissioniSync = this.dataService.emissioni$.subscribe(
			emissioni => {
				this.emissioni = emissioni;
			});
		console.log('datiPratica',this.datiPratica);
	}

	canAdd() {
		if (this.datiPratica) {
			if (this.dataPagamento && this.dataAccredito && this.sommaPagata && this.rata != null && this.canale) {
				return true;
			}
			else {
				return false;
			}
		}
		else {
			return false;
		}

	}

	aggiungiPagamento() {
		console.log("salvaPagamento", this.datiPratica);
		//let newId = this.dataService.insertPagamento(this.datiPratica.id, pagamento);

		let event = {
			hide: true,
			aggiungiPagamento: true,
			uid: this.datiPratica.id,
			id_prat: this.datiPratica.id_prat,
			setValue: {
				uid: this.datiPratica.id,
				dataPagamento: this.dataPagamento,
				dataAccredito: this.dataAccredito,
				sommaPagata: this.sommaPagata,
				rifBoll: this.riferimentoBollettino,
				rifRata: this.rata,
				canale_pagamento_id: this.canale
			},
			//content: newId
		}
		console.log("INNER-PAGAMENTI-ADD: event", event);
		this.innerEvents.emit(event);
		this.reset();
	}

	reset() {
		this.sommaPagata = this.formatter.twoDigitsDecimal(0);
		this.dataPagamento = null;
		this.dataAccredito = null;
		this.canale = null;
		this.rata = 0;
	}

	setTwoDigitsDecimal() {
		this.sommaPagata = this.formatter.twoDigitsDecimal(this.sommaPagata);
	}

	ngOnDestroy() {
		this.canaliPagamentoSync.unsubscribe();
		this.emissioniSync.unsubscribe();
	}
}
